<template>
  <popup-dialog
    :close-button-visible="true"
    :title="$t('labels.options')"
    class="popup-rounded"
    @close="close"
  >
    <div class="p-6">
      <p style="text-align: center" class="mt-1">
        {{ $t("headings.modelOverviewSettings") }}
      </p>

      <div class="popup__section">
        <div class="subtitle">
          {{ $t("labels.modelOrder") }}
        </div>
        <radio-button
          :value="orderBy"
          :label="$t('labels.alphabetical')"
          :data="('name' as const)"
          @update:value="$emit('update:orderBy', $event)"
        />
        <radio-button
          :value="orderBy"
          :label="$t('labels.dateModified')"
          :data="('modified' as const)"
          @update:value="$emit('update:orderBy', $event)"
        />
      </div>

      <div class="popup__section">
        <div class="subtitle">
          {{ $t("labels.modelDescription") }}
        </div>
        <radio-button
          :value="showDescriptions"
          :label="$t('labels.hide')"
          :data="false"
          @update:value="$emit('update:showDescriptions', $event)"
        />
        <radio-button
          :value="showDescriptions"
          :label="$t('labels.show')"
          :data="true"
          @update:value="$emit('update:showDescriptions', $event)"
        />
      </div>

      <div class="popup__buttons">
        <button type="button" class="button" @click="close">
          {{ $t("labels.confirm") }}
        </button>
      </div>
    </div>
  </popup-dialog>
</template>

<script setup lang="ts">
import PopupDialog from "@core/ui/PopupDialog.vue";
import RadioButton from "@core/input/RadioButton.vue";

import { useUser } from "@/api/user.store";
import { showError } from "@core/ui/alert/alert";
import { NoInternetError } from "@core/errors/Errors";

const props = withDefaults(defineProps<{
  orderBy: "modified" | "created" | "name";
  showDescriptions: boolean;
}>(), {
  orderBy: "modified",
  showDescriptions: true
});

const emit = defineEmits<{
  (event: "update:orderBy", value: "modified" | "created" | "name"): void;
  (event: "update:showDescriptions", value: boolean): void;
  (event: "close"): void;
}>();

const { user, updateUser } = useUser();

async function close() {
  emit("close");

  if (user.value) {
    // Save the settings to the user.
    try {
      await updateUser({
        id: user.value.id,
        preferredModelOrder: props.orderBy,
        showModelDetails: props.showDescriptions
      });
    } catch (error) {
      if (error instanceof NoInternetError) {
        console.warn("could not save user preference online.", error);
      } else {
        showError(error as Error);
      }
    }
  }
}
</script>

<style lang="scss"></style>
